import HistoryIcon from "@mui/icons-material/History";
import SettingsIcon from "@mui/icons-material/Settings";
import { Divider, Menu, MenuItem } from "@mui/material";
import React from "react";

interface ActionsMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onHistoryClick: () => void;
  /** Abre o modal de config de campos por campanha (apenas admin). Quando definido, exibe o item "Campos". */
  onOpenConfig?: () => void;
}

const ActionsMenu: React.FC<ActionsMenuProps> = ({
  anchorEl,
  open,
  onClose,
  onHistoryClick,
  onOpenConfig,
}) => {
  const handleHistoryClick = () => {
    onClose();
    onHistoryClick();
  };

  const handleConfigClick = () => {
    onClose();
    onOpenConfig?.();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            borderRadius: "8px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
            border: "1px solid #e9edef",
            minWidth: "200px",
            mt: 0.5,
          },
        },
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
    >
      <MenuItem
        onClick={handleHistoryClick}
        sx={{
          py: 1.5,
          px: 2,
          fontSize: "13px",
          fontWeight: 500,
          color: "#111b21",
          "&:hover": {
            backgroundColor: "#f0f2f5",
            color: "#00a884",
          },
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <HistoryIcon sx={{ fontSize: 18, color: "#00a884" }} />
        Histórico de Cópias
      </MenuItem>
      {onOpenConfig && (
        <>
          <Divider sx={{ my: 0.5 }} />
          <MenuItem
            onClick={handleConfigClick}
            sx={{
              py: 1.5,
              px: 2,
              fontSize: "13px",
              fontWeight: 500,
              color: "#111b21",
              "&:hover": {
                backgroundColor: "#f0f2f5",
                color: "#00a884",
              },
              display: "flex",
              alignItems: "center",
              gap: 1.5,
            }}
          >
            <SettingsIcon sx={{ fontSize: 18, color: "#00a884" }} />
            Campos por campanha
          </MenuItem>
        </>
      )}
    </Menu>
  );
};

export default ActionsMenu;
